module.exports = __webpack_public_path__ + "media/img/favicon/favicon-16x16-0f491529c3655e678344f89da127b89e.png";